<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <h2>Manage Vendors</h2>
          </div>
          <div class="body">
            <div class="table-responsive">
              <table id="vendor-list" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr>
                  <th class="no-sort"></th>
                  <th></th>
                  <th>Name</th>
                  <th>Position</th>
                  <th>Office</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                </tr>
                </thead>
                <tfoot>
                <tr>
                  <th class="no-sort"></th>
                  <th></th>
                  <th>Name</th>
                  <th>Position</th>
                  <th>Office</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                  <th>Salary</th>
                </tr>
                </tfoot>
                <tbody>

                <tr>
                  <td class="details-control" [id]="'td-'" ></td>
                  <td>Junior Technical Author</td>
                  <td>San Francisco</td>
                  <td>66</td>
                  <td>2009/01/12</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                </tr>
                <tr>
                  <td class="details-control" [id]="'td-'" ></td>
                  <td>Junior Technical Author</td>
                  <td>San Francisco</td>
                  <td>66</td>
                  <td>2009/01/12</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                </tr>
                <tr>
                  <td class="details-control" [id]="'td-'" ></td>
                  <td>Junior Technical Author</td>
                  <td>San Francisco</td>
                  <td>66</td>
                  <td>2009/01/12</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                  <td>$86,000</td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
